var recoveryForm = document.getElementById("login__recovery");
var recoveryButton = document.getElementById("RecoverPassword");
var recoveryFormClose = document.getElementById("login__recovery--close");
var recoveryToggle = false;

if (recoveryButton !== null) {
  recoveryButton.onclick = function () {
    recoveryToggle = true;
    recoveryFormToggle();
  };
}

if (recoveryFormClose !== null) {
  recoveryFormClose.onclick = function () {
    recoveryToggle = false;
    recoveryFormToggle();
  };
}

function recoveryFormToggle() {
  if (recoveryToggle) {
    recoveryForm.classList.add("form__show");
  } else {
    recoveryForm.classList.remove("form__show");
  }
}
